// src/components/common/LanguageSwitcher.jsx
import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Globe, Check } from 'lucide-react'
import clsx from 'clsx'
import { SUPPORTED_LANGUAGES } from '@/i18n'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const currentLang = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0]

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  const switchLanguage = (code) => {
    i18n.changeLanguage(code)
    setOpen(false)
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-gray-500 hover:text-gray-700 transition-colors px-2 py-1.5 rounded-lg hover:bg-gray-100 text-sm font-medium"
        aria-label="Switch language"
      >
        <Globe size={16} />
        <span>{currentLang.shortLabel}</span>
      </button>

      <div
        className={clsx(
          'absolute right-0 top-full mt-1 w-40 bg-white rounded-lg shadow-lg border border-gray-200 z-50 py-1',
          'transition-all duration-150 origin-top-right',
          open
            ? 'opacity-100 scale-100'
            : 'opacity-0 scale-95 pointer-events-none'
        )}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => switchLanguage(lang.code)}
            className={clsx(
              'w-full flex items-center justify-between px-3 py-2 text-sm transition-colors',
              lang.code === i18n.language
                ? 'text-[#0d2757] bg-blue-50 font-semibold'
                : 'text-gray-600 hover:bg-gray-50'
            )}
          >
            <span>{lang.label}</span>
            {lang.code === i18n.language && <Check size={14} />}
          </button>
        ))}
      </div>
    </div>
  )
}
